import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import { Box, Stack, Typography } from "@mui/material";
import { CONTRACT_UX } from "./contractUxTheme";

const ICONS = {
  profile: PersonOutlineIcon,
  review: DescriptionOutlinedIcon,
  sign: AssignmentTurnedInOutlinedIcon,
  guarantee: SecurityOutlinedIcon,
  active: LockOutlinedIcon,
};

/**
 * Phase 7.7.4 — Horizontal professional progress timeline.
 */
const ContractProgressTracker = ({ steps = [] }) => {
  if (!steps.length) return null;

  return (
    <Box
      data-testid="contract-progress-tracker"
      dir="rtl"
      sx={{
        px: CONTRACT_UX.cardPadding,
        py: 2,
        borderRadius: 2,
        bgcolor: "#fff",
        border: `1px solid ${CONTRACT_UX.cardBorder}`,
      }}
    >
      <Typography variant="subtitle2" fontWeight={800} sx={{ mb: 1.75 }}>
        مسیر فعال‌سازی همکاری
      </Typography>

      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ xs: "stretch", md: "flex-start" }}
        justifyContent="space-between"
        spacing={{ xs: 1.5, md: 0 }}
      >
        {steps.map((step, index) => {
          const Icon = ICONS[step.id] || DescriptionOutlinedIcon;
          const isDone = step.state === "done";
          const isCurrent = step.state === "current";
          const color = isDone
            ? CONTRACT_UX.success
            : isCurrent
            ? CONTRACT_UX.warning
            : "#98A2B3";
          const showConnector = index < steps.length - 1;

          return (
            <Stack
              key={step.id}
              direction={{ xs: "row", md: "column" }}
              alignItems="center"
              spacing={1}
              sx={{ flex: 1, position: "relative", minWidth: 0 }}
              data-testid={`progress-step-${step.id}`}
              data-state={step.state}
            >
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: isDone || isCurrent ? `${color}18` : "#F2F4F7",
                  border: `2px solid ${color}`,
                  color,
                  zIndex: 1,
                }}
              >
                {isDone ? (
                  <CheckCircleIcon sx={{ fontSize: 22 }} />
                ) : (
                  <Icon sx={{ fontSize: 20 }} />
                )}
              </Box>

              {showConnector ? (
                <Box
                  aria-hidden
                  sx={{
                    display: { xs: "none", md: "block" },
                    position: "absolute",
                    top: 19,
                    left: 0,
                    right: "50%",
                    height: 2,
                    bgcolor: isDone ? CONTRACT_UX.success : "#E4E7EC",
                    transform: "translateX(-50%)",
                    width: "100%",
                    zIndex: 0,
                  }}
                />
              ) : null}

              <Box
                sx={{
                  textAlign: { xs: "right", md: "center" },
                  px: { md: 0.5 },
                  flex: 1,
                }}
              >
                <Typography
                  variant="body2"
                  fontWeight={isCurrent ? 800 : 600}
                  color={isCurrent || isDone ? "text.primary" : "text.secondary"}
                >
                  {step.label}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{ color, fontWeight: 600 }}
                  data-testid={`progress-step-${step.id}-status`}
                >
                  {step.statusLabel}
                </Typography>
              </Box>
            </Stack>
          );
        })}
      </Stack>
    </Box>
  );
};

export default ContractProgressTracker;
